var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form.errors && _vm.form.errors.has(_vm.inputName))?_c('p',{staticClass:"mt-2 text-sm text-red-600",domProps:{"textContent":_vm._s(_vm.form.errors.get(_vm.inputName))}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }